module.exports = __webpack_public_path__ + "static/img/mxk.6a38e3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/mxk.png
// module id = mrNk
// module chunks = 1